import gql from 'graphql-tag';

export const declineChallengeMutation = gql`
	mutation DeclineChallenge($input: ChallengeInput) {
		declineChallenge(input: $input) {
			id
		}
	}
`;
